import { Col, Container, Row, Button } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';

// components
import { FormInput } from '../form';
import SwiperSlider5 from '../sliders/SwiperSlider5';
import { Link } from 'react-router-dom';
import Swiper, { Autoplay } from 'swiper';
import { SwiperSlide } from 'swiper/react';





const Hero12 = () => {
    return (
        // <section >
        <div className=" position-relative overflow-hidden hero-13">


            <Row className='hero-right' >
                {/* <div> */}
                <div className="img-container">
                    <SwiperSlider5 />
                </div>
                {/* </div> */}
            </Row>
        </div>
        // </section>
    );
};

export default Hero12;





